import React from 'react';
export const DoorClosed = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`btfont ${props.className ? props.className : ''}`}><path d="M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v13h1.5a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1H3V2zm1 13h8V2H4v13z" fillRule="evenodd" />,
<path d="M9 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0z" fillRule="evenodd" /></svg>
);
